import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandlerFn,
    HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { AuthService } from '../../services/auth.service';

/**
 * Intercept
 *
 * @param req
 * @param next
 */
export const authInterceptor = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const authService = inject(AuthService);

    // Clone the request object
    let newReq = req.clone();

    // Skip authentication for Cloudinary API requests
    const isCloudinaryRequest = req.url.includes('api.cloudinary.com');

    // Skip authentication for Manager.io API requests (uses X-API-KEY header instead)
    const isManagerIoRequest = req.url.includes('manager.io/api');

    // If token is valid and not a Cloudinary or Manager.io request, add authorization header
    if (
        authService.getAccessToken() &&
        !isCloudinaryRequest &&
        !isManagerIoRequest
    ) {
        newReq = req.clone({
            headers: req.headers.set(
                'Authorization',
                `Bearer ${authService.getAccessToken()}`
            ),
        });
    }

    // Handle the request and other errors
    return next(newReq).pipe(
        catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
                // Handle 401 Unauthorized
                authService.signOut();
                location.reload();
            }
            return throwError(() => error);
        })
    );
};
